import { FC, ReactNode } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
  MainLayoutContainer,
  LinksContainer,
  LinkItem,
  MainLayoutCustomerBody,
  MainLayoutCustomerTitle,
  MainLayoutCustomerSubtitle,
  MainLayoutCustomerBodyHeader
} from './styles'
import tlieLogoImg from 'src/assets/texas-lawyers-insurance-logo.svg'
import { portalLinks } from 'src/constants/portal'
import { useCustomer } from 'src/context/customer'
import { parseISO, differenceInCalendarDays } from 'date-fns'
import Reminder from 'src/components/basic/ReminderCard'
import { FlexDiv } from '../default'
import Button from 'src/components/basic/Button'

interface Props {
  children?: ReactNode
}

const MainLayout: FC<Props> = ({ children }) => {
  const { pathname }  = useLocation()
  const { firmData } = useCustomer()
  const navigate = useNavigate()

  const [_, portalType] = pathname.split('/')

  const currentLinks = portalLinks[portalType]

  const today = firmData?.today ? parseISO(firmData.today) : new Date()
  const expiry = firmData?.policyExpiryDate ? parseISO(firmData.policyExpiryDate) : null
  const daysFromExpiry = expiry ? differenceInCalendarDays(today, expiry) : null
  const inRenewalWindow = daysFromExpiry !== null && daysFromExpiry >= -90 && daysFromExpiry <= 90

  const renewalBannerHeading =
    daysFromExpiry === null ? '' :
    daysFromExpiry < 0 ? 'Your policy is approaching expiration.' :
    daysFromExpiry === 0 ? 'Your policy expires today.' :
    'Your policy has expired.'

  return (
    <MainLayoutContainer id="admin-main-portal-container" portalType={portalType}>
      <aside>
        <header>
          <Link to={`/${portalType}`}>
            <img src={tlieLogoImg} alt="Logo" width="132px" />
          </Link>
        </header>
        <LinksContainer>
          {currentLinks.map(link => (
            <LinkItem key={link.route} selected={link.route === pathname} to={link.route}>{link.name}</LinkItem>
          ))}
        </LinksContainer>
      </aside>
      {(portalType === 'customer' && firmData.name) ? (
        <MainLayoutCustomerBody>
          {inRenewalWindow ? (
            <FlexDiv>
              <Reminder
                icon='warning'
                title=''
              >
                <FlexDiv dir="row">
                  <FlexDiv dir="column">
                    <strong style={{color: '#E84242', fontSize: '18px'}}>{renewalBannerHeading}</strong>
                    <span>Submit a renewal application if you'd like consideration for renewing your policy.</span>
                  </FlexDiv>
                  <Button
                    padding='5px 48px'
                    style={{marginLeft: 'auto'}}
                    onClick={() => navigate('/customer/renew/begin')}
                  >
                    START RENEWAL
                  </Button>
                </FlexDiv>
              </Reminder>
            </FlexDiv>
          ) : null}
          <MainLayoutCustomerBodyHeader>
            <MainLayoutCustomerTitle>{firmData.name}</MainLayoutCustomerTitle>
            <MainLayoutCustomerSubtitle>Firm #{firmData.number}</MainLayoutCustomerSubtitle>
          </MainLayoutCustomerBodyHeader>
          <main>{children}</main>
        </MainLayoutCustomerBody>
      ) : (
        <main>{children}</main>
      )}
    </MainLayoutContainer>
  )
}

export default MainLayout